<template>
    <div class="AIAssistant" :class="{ 'ai-assistant--expanded': isExpanded }">
        <!-- 助手按钮 -->
        <button class="ai-assistant__toggle" v-if="showAIAssistantBtn" :aria-expanded="isExpanded" @click="toggleAssistant"></button>
        <!-- 助手面板 -->
        <div v-show="isExpanded" class="ai-assistant__panel" :class="{ 'ai-assistant__panel_fullScreen': isFullScreen }">
            <div class="ai-assistant__header">
                <h3 class="ai-assistant__header-title">
                    {{ assistantInfo[0]?.app_name || '智能助手' }}
                </h3>
                <div class="ai-assistant__header-btn">
                    <button class="iconfont ai-shezhi"></button>
                    <button class="iconfont ai-qingchuhuancun" @click="clearAssistant"></button>
                    <button class="iconfont" @click="isFullScreen = !isFullScreen">
                        {{ isFullScreen ? '&#xe6d5;' : '&#xe678;' }}
                    </button>
                </div>
                <div class="ai-assistant__header-close" @click="isExpanded = !isExpanded">
                    ×
                </div>
            </div>
            <div class="ai-assistant__content">
                <el-x-welcome v-if="bubbleItems.length === 0" title="很高兴见到你！有什么我能帮你的吗？" :description=" assistantInfo[0]?.welcome_message || '我可以帮你写代码、读文件、写作各种创意内容，请把你的任务交给我吧~'">
                    <template #image>
                        <img class="logo" src="../assets/images/logo.gif" alt="logo">
                    </template>
                </el-x-welcome>
                <!-- 对话气泡列表 -->
                <el-x-bubble-list :list="bubbleItems" v-if="bubbleItems.length > 0" :auto-scroll="true" class="el-bubble-list">
                    <!-- 自定义头像 -->
                    <template #avatar="{ item }">
                        <div class="avatar-wrapper" v-if="item.role === 'ai'">
                            <img src="../assets/images/assistant.gif" alt="avatar">
                        </div>
                    </template>
                    <!-- 自定义头部 -->
                    <template #header="{ item }">
                        <div class="header-wrapper" v-if="item.role === 'ai'">
                            <!-- <div class="header-name">
                                {{ item.role === 'ai' ? '智能助手' : '' }}
                            </div> -->
                            <el-x-thinking v-model="thinkingStatus" max-width="88%" :status="item.thinkingStatus || 'start'" :auto-collapse="true" :content="item.thinkingSteps || '正在思考...'" color="red" @change="thoughtProcess(item)">
                                <template #content>
                                    <el-x-typewriter
                                        :ref="`ref_thoughtProcessTypewriter_${item.key}`"
                                        :content="item.thinkingSteps || '正在思考...'"
                                        :is-markdown="true"
                                        :typing="{ step: 3, interval: 40 }"
                                        :is-fog="true"
                                    ></el-x-typewriter>
                                </template>
                            </el-x-thinking>
                        </div>
                    </template>
                    <!-- 自定义气泡内容 -->
                <template #content="{ item }">
                    <div class="content-wrapper">
                        <div class="content-text">
                            <el-x-typewriter :ref="`ref_typewriter_${item.key}`" :content="item.text" :is-markdown="true" :is-fog="true" :typing="{ step: 3, interval: 40 }" @finish="getInstance"></el-x-typewriter>
                        </div>
                        <!-- 显示用户上传的文件 -->
                        <div v-if="item.role === 'user' && item.hasFiles" class="user-files">
                            <div v-for="(file, index) in item.files" :key="index" class="file-item">
                                <!-- 图片文件预览 -->
                                <div v-if="file.imgFile && file.imgFile.type.startsWith('image/')" class="image-preview">
                                    <el-image :src="file.url" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2" :initial-index="4" fit="cover" :preview-src-list="[file.url]"></el-image>
                                    <div class="file-name">{{ file.name }}</div>
                                </div>
                                <!-- 非图片文件信息 -->
                                <div v-else class="file-info fileCardStyle">
                                    <div class="file-icon">
                                        <svg class="fileIcom" :class="loadIconClass(file.name)" aria-hidden="true">
                                            <use :xlink:href="`#${loadIconClass(file.name)}`"></use>
                                        </svg>
                                    </div>
                                    <div class="file-details">
                                        <div class="file-name">{{ file.name }}</div>
                                        <div class="file-size">大小: {{ (file.fileSize / 1024).toFixed(2) }} KB</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                    <!-- 自定义底部 -->
                    <template #footer="{ item }">
                        <div class="footer-wrapper" v-if="item.loadComplete">
                            <div class="footer-container">
                                <el-button type="primary" size="small" circle class="iconfont" @click="copyText(item.text)">
                                    &#xe707;
                                </el-button>
                                <el-button type="success" size="small" circle class="iconfont" v-if="item.role === 'ai'" @click="refreshText(item.text)">
                                    &#xe619;
                                </el-button>
                                <el-button type="warning" size="small" circle class="iconfont" @click="voiceAnnouncements(item.text, item)">
                                    {{ loadVoiceButton(item) }}
                                </el-button>
                            </div>
                        </div>
                    </template>
                </el-x-bubble-list>
                <!-- 提示集 -->
                <div class="prompts-container">
                    <el-x-prompts v-if="showPrompts" :items="promptList" @on-item-click="handlePromptClick"></el-x-prompts>
                </div>
            </div>
            <div class="ai-assistant__footer">
                <!-- 输入框 -->
                <el-x-sender
                    clearable
                    allow-speech
                    ref="senderRef"
                    variant="updown"
                    v-model="senderValue"
                    class="chat-defaul-sender"
                    :loading="senderLoading"
                    :auto-size="{ maxRows: 9, minRows: 3 }"
                    :show-send="false"
                    @submit="handleSend"
                    @cancel="cancelSend"
                    @clear="clearSend"
                >
                    <template #header>
                        <div class="sender-header p-12px pt-6px pb-0px">
                            <!-- 输入框内附件，支持显示解析中状态 -->
                            <div class="sender-attachments" v-show="!hideAttachments">
                                <el-x-attachments :items="files" :hide-upload="true" :show-delete="true" @delete-card="(file, index) => deleteFileCard(file, index)">
                                    <template #file-list="{ items }">
                                        <!-- 使用我们在CSS中定义的容器类 -->
                                        <div class="file-card-container" v-for="(file, index) in items" :key="`file-card_${index}`">
                                            <div class="el-x-attachments-card fileCardStyle" v-loading="file.parsing" element-loading-text="文件解析中..." element-loading-background="rgba(0, 0, 0, 0.7)">
                                                <div class="file-icon">
                                                    <svg class="fileIcom" :class="loadIconClass(file.name)" aria-hidden="true">
                                                        <use :xlink:href="`#${loadIconClass(file.name)}`"></use>
                                                    </svg>
                                                </div>
                                                <div class="file-details">
                                                    <div class="file-name">{{ file.name }}</div>
                                                    <div class="file-size">大小: {{ (file.fileSize / 1024).toFixed(2) }} KB</div>
                                                </div>
                                                <div class="file-delete" v-if="!file.parsing" @click="deleteFileCard(file, index)">
                                                    <i class="el-icon-close"></i>
                                                </div>
                                            </div>

                                            <!-- 使用我们在CSS中定义的parse-error-indicator类 -->
                                            <div v-if="items.parseError" class="parse-error-indicator">
                                                <i class="el-icon-circle-close"></i>
                                                <span>{{ items.errorMessage || '解析失败' }}</span>
                                            </div>
                                        </div>
                                    </template>
                                </el-x-attachments>
                            </div>
                        </div>
                    </template>
                    <template #prefix>
                        <div class="flex-1 flex items-center gap-8px flex-none w-fit overflow-hidden">
                            <FilesSelect :load-files="loadFiles"></FilesSelect>
                            <el-button circle size="small" title="折叠文件" v-if="files.length" class="iconfont ai-wenjian1" @click="hideAttachments = !hideAttachments"></el-button>
                        </div>
                    </template>

                    <!-- 自定义发送按钮 -->
                    <template #action-list>
                        <!-- 清空按钮 -->
                        <el-button size="small" circle class="iconfont" @click="clearAll" :title="senderLoading ? '清空并停止生成' : '清空输入和文件'" :disabled="senderLoading && !isRecording && !senderValue.trim()">
                            {{ '\ue61f' }}
                        </el-button>

                        <!-- 语音功能按钮 -->
                        <el-button size="small" circle class="iconfont" :title="isRecording ? '停止录音' : '语音输入'" @click="toggleSpeechRecognition" :disabled="senderLoading && !isRecording">
                            {{ isRecording ? '\ue76f' : '\ue8a0' }}
                        </el-button>

                        <!-- 暂停/继续按钮 -->
                        <el-button v-if="senderLoading" :type="isPaused ? 'success' : 'warning'" size="small" circle class="iconfont" @click="togglePause" :title="isPaused ? '继续生成' : '暂停生成'">
                            {{ isPaused ? '\ue8bc' : '\ue76f' }}
                        </el-button>

                        <!-- 发送按钮 -->
                        <el-button size="small" circle class="iconfont" v-if="!senderLoading" @click="handleSend" :disabled="!senderValue.trim()" title="发送消息">
                            {{ '\ue7c5' }}
                        </el-button>
                    </template>
                </el-x-sender>
            </div>
        </div>
    </div>
</template>

<script>
import '../assets/style/AIAssistant.styl';
import '../assets/fonts/iconfont/iconfont.css';
import '../assets/fonts/iconfont/iconfont.js';
import { Message } from 'element-ui';
import { ElXWelcome, ElXPrompts, ElXBubbleList, ElXSender, ElXAttachments, ElXTypewriter, ElXThinking } from 'vue-element-ui-x';
import FilesSelect from '../components/FilesSelect/index.vue'

export default {
    name: 'a-i-assistant',
    components: {
        ElXWelcome: ElXWelcome || null,
        ElXPrompts: ElXPrompts || null,
        ElXBubbleList: ElXBubbleList || null,
        ElXSender: ElXSender || null,
        ElXAttachments: ElXAttachments || null,
        ElXTypewriter: ElXTypewriter || null,
        ElXThinking: ElXThinking || null,
        FilesSelect,
    },
    props: '',

    // 配置常量
    constants: {
        // 文件处理配置
        MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
        MAX_RETRIES: 3,
        BASE_DELAY: 1000,
        MAX_DELAY: 10000,

        // 请求配置
        API_TIMEOUT: 30000,
        STATUS_TIMEOUT: 15000,

        // UI配置
        MESSAGE_DURATION: {
            INFO: 2000,
            SUCCESS: 1500,
            ERROR: 5000,
        },

        // 日志配置
        LOG_PREFIX: '[AIAssistant]',
    },
    data() {
        return {
            assistantInfo: {},
            uniqueCode: '',
            isFullScreen: false,
            isExpanded: false,
            senderLoading: false,
            senderValue: '',
            showPrompts: true,
            thinkingStatus: true,
            files: [],
            bubbleItems: [],
            abortController: null,
            // 会话ID，用于关联阿里云百炼API上下文
            sessionId: '',
            // 存储上传的文件ID数组，支持多文件上传
            lastUploadedFileId: [],

            // 语音播报对象
            currentUtterance: null,
            // 语音播放状态
            voiceStatus: 'stopped',
            // 当前正在播报的项
            currentVoiceItem: null,
            // 默认提示集
            promptList: [],
            // 暂停相关状态
            isPaused: false,
            pausedReader: null,
            pausedBuffer: '',
            pausedResponse: null,
            // 语音识别相关状态
            isRecording: false,
            recognition: null,

            hideAttachments: false,
            hasPermission: true,

            showAIAssistantBtn: false,
        };
    },
    async created() {
        
    },
    async mounted() {
        const res = await this.getuserllmapps();
        if ((res || []).length > 0) {
            this.showAIAssistantBtn = true;
            this.uniqueCode = res[0]?.unique_code;
            try {
                this.assistantInfo = await this.getAssistantInfo();
                if ((this.assistantInfo || []).length > 0 && this.assistantInfo[0].unique_code) {
                    this.promptList = await this.getPromptList();
                }
                this.userWorkSpaces = await this.getuserworkspaces();
                if (!this.userWorkSpaces || this.userWorkSpaces.length === 0) {
                    this.hasPermission = false;
                }
            } catch (error) {
                console.error('初始化用户工作区失败:', error);
                this.userWorkSpaces = [];
                this.hasPermission = false;
            }
        } else {
            this.showAIAssistantBtn = false;
            // this.$message({ showClose: true, message: '当前账号暂无AI小助手权限！', type: 'warning' });
        }
        
    },
    computed: {},
    methods: {
        // 清理资源
        cleanupResources() {
            // 清理语音识别相关资源
            if (this.recognition) {
                this.recognition.abort();
                this.recognition.onstart = null;
                this.recognition.onresult = null;
                this.recognition.onend = null;
                this.recognition.onerror = null;
                this.recognition = null;
            }

            // 停止语音播报
            if (window.speechSynthesis) {
                window.speechSynthesis.cancel();
            }

            // 取消请求
            if (this.abortController) {
                this.abortController.abort();
                this.abortController = null;
            }

            // 释放URL对象
            const urlCount = this.bubbleItems.filter(item => item.imgUrl).length;
            this.bubbleItems.forEach(item => {
                if (item.imgUrl) {
                    URL.revokeObjectURL(item.imgUrl);
                }
            });

            // 清理定时器
            if (this.pollingTimer) {
                clearInterval(this.pollingTimer);
                this.pollingTimer = null;
            }
        },

        // 重置状态
        resetState() {
            // 取消正在进行的请求
            if (this.abortController) {
                this.abortController.abort();
                this.abortController = null;
            }

            // 停止语音播报
            if (this.currentUtterance) {
                window.speechSynthesis.cancel();
                this.currentUtterance = null;
                this.currentVoiceItem = null;
            }

            // 重置流式响应状态
            this.isPaused = false;
            this.pausedReader = null;
            this.pausedBuffer = '';
            this.pausedResponse = null;
        },

        // =================== UI控制方法 ===================
        // 清空历史记录
        clearAssistant() {
            this.bubbleItems = [];
            this.showPrompts = true;
            this.clearAll();
            // this.files = [];
            // if (this.$refs.senderRef) {
            //     this.$refs.senderRef.closeHeader();
            // }
            // this.senderValue = '';
            // this.resetState();
            // this.sessionId = '';
        },

        // 关闭助手面板
        // closeAIAssistant() {
        //     this.isExpanded = false;
        //     this.isFullScreen = false;
        //     this.clearAssistant();
        // },

        // 提示集组件点击事件
        handlePromptClick(item) {
            this.senderValue = item.data.label || '';
            this.handleSend();
        },

        // 查询
        async handleSend() {
            if (!this.senderValue.trim()) {
                Message({ showClose: true, message: '请输入查询内容', type: 'warning' });
                return;
            }

            // 如果已经有请求在进行中，直接返回
            if (this.senderLoading) {
                Message({ showClose: true, message: '请求正在进行中，请稍候...', type: 'info' });
                return;
            }

            this.showPrompts = false;
            this.senderLoading = true;
            // 构建包含文件信息的用户消息
            const userMessage = this.senderValue;
            const hasFiles = this.files.length > 0;
            // 检查是否有新文件（第一次上传的文件）
            let hasNewFilesToShow = false;
            const newFilesToShow = [];
            if (hasFiles) {
                for (let i = 0; i < this.files.length; i++) {
                    const file = this.files[i];
                    // 如果文件有fileId但尚未在气泡中显示过，则标记为新文件
                    if (file.fileId && !file.shownInBubble) {
                        hasNewFilesToShow = true;
                        newFilesToShow.push({...file, shownInBubble: true});
                    }
                }
            }

            // 确保所有文件都有fileId，如果没有则上传并解析
            if (hasFiles) {
                try {
                    let hasNewFiles = false;
                    for (let i = 0; i < this.files.length; i++) {
                        const file = this.files[i];
                        // 如果文件还没有fileId，则调用readFileContent获取
                        if (!file.fileId && file.imgFile) {
                            hasNewFiles = true;
                            // 添加文件处理进度提示
                            Message({ showClose: true, message: `正在处理文件: ${file.name}`, type: 'info', duration: 2000 });
                            const fileResult = await this.readFileContent(file);
                            // 保存fileId到文件对象中
                            this.files[i].fileId = fileResult.fileId;
                            // 将新上传文件的ID添加到数组中，避免重复
                            if (!this.lastUploadedFileId.includes(fileResult.fileId)) {
                                this.lastUploadedFileId.push(fileResult.fileId);
                            }
                        } else if (file.fileId) {
                            // 如果文件已有fileId，检查并添加到数组中避免重复
                            if (!this.lastUploadedFileId.includes(file.fileId)) {
                                this.lastUploadedFileId.push(file.fileId);
                            }
                        }
                    }
                    // 只有有新文件处理且文件ID数组不为空时才显示成功提示
                    if (hasNewFiles && this.lastUploadedFileId.length > 0) {
                        Message({ showClose: true, message: '文件处理完成，正在发送请求...', type: 'success', duration: 1500 });
                    }
                } catch (error) {
                    // 根据错误类型显示不同的提示
                    let errorMsg = '文件处理失败';
                    if (error.message) {
                        if (error.message.includes('文件大小超过限制')) {
                            errorMsg = error.message;
                        } else if (error.message.includes('解析') || error.message.includes('JSON')) {
                            errorMsg = '文件格式不支持或文件内容有误';
                        } else if (error.message.includes('超时')) {
                            errorMsg = '文件处理超时，请稍后重试';
                        } else {
                            errorMsg = `文件处理失败: ${error.message}`;
                        }
                    }
                    Message({
                        showClose: true,
                        message: errorMsg,
                        type: 'error',
                        duration: 5000, // 错误提示显示时间更长
                    });

                    this.senderLoading = false;
                    return;
                }
            }

            // 更新原始files数组中的shownInBubble标记
            if (hasNewFilesToShow) {
                for (let i = 0; i < this.files.length; i++) {
                    const file = this.files[i];
                    if (file.fileId && !file.shownInBubble) {
                        this.files[i].shownInBubble = true;
                    }
                }
            }

            this.bubbleItems.push(
                {
                    key: this.bubbleItems.length + 1,
                    role: 'user',
                    placement: 'end',
                    variant: 'borderless',
                    maxWidth: '80%',
                    text: userMessage, // 基本文本内容
                    files: hasNewFilesToShow ? newFilesToShow : [],
                    imgUrl: hasNewFilesToShow && newFilesToShow.length > 0 ? newFilesToShow[0].url : '',
                    hasFiles: hasNewFilesToShow,
                    loadComplete: true,
                    voiceStatus: 'stopped', // 初始化语音状态
                },
                {
                    key: this.bubbleItems.length + 2,
                    role: 'ai',
                    placement: 'start',
                    variant: 'borderless',
                    maxWidth: '88%',
                    text: '',
                    finalText: '',
                    loading: true,
                    loadComplete: false,
                    voiceStatus: 'stopped', // 初始化语音状态
                    thinkingSteps: '', // 初始化思考过程
                    thinkingStatus: 'start', // 初始状态为 start
                    typingComplete: false, // 标记打字是否完成
                }
            );

            // 清空输入框和文件列表
            this.senderValue = '';
            // this.files = [];

            let allText = '';
            try {
                // 将用户消息（包含文件信息）和所有上传的文件ID传递给API
                // 直接使用lastUploadedFileId数组，它已经包含了所有需要传递的文件ID
                const fileIdsToSend = this.lastUploadedFileId;
                await this.callDeepseekAPI(userMessage, fileIdsToSend, text => {
                    allText = `${allText}${text}`;
                    // 先将完整内容存储到finalText，不立即更新text
                    this.bubbleItems[this.bubbleItems.length - 1].finalText = allText;
                    this.bubbleItems[this.bubbleItems.length - 1].loading = false;

                    // 只有在打字未完成时才更新text，用于打字动画
                    if (!this.bubbleItems[this.bubbleItems.length - 1].typingComplete) {
                        this.bubbleItems[this.bubbleItems.length - 1].text = allText;
                    }
                });
            } catch (error) {
                this.bubbleItems[this.bubbleItems.length - 1].thinkingStatus = 'error';

                // 设置错误消息文本
                let errorMessage = '很抱歉，请求过程中遇到了问题';

                if (error.response) {
                    // 服务器返回错误
                    if (error.response.status === 401 || error.response.status === 403) {
                        errorMessage = '认证失败，请重新登录';
                    } else if (error.response.status === 429) {
                        errorMessage = '请求过于频繁，请稍后再试';
                    } else if (error.response.status >= 500) {
                        errorMessage = '服务器繁忙，请稍后再试';
                    } else if (error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                } else if (error.request) {
                    // 网络错误
                    errorMessage = '网络连接失败，请检查您的网络设置';
                } else if (error.message) {
                    // 其他错误
                    if (error.message.includes('timeout') || error.message.includes('超时')) {
                        errorMessage = '请求超时，请稍后重试';
                    }
                }
                // 在AI回复中显示错误消息
                this.bubbleItems[this.bubbleItems.length - 1].text = errorMessage;
                // 显示错误提示
                Message({
                    showClose: true,
                    message: errorMessage,
                    type: 'error',
                    duration: 5000,
                });
            } finally {
                if (this.bubbleItems.length > 0) {
                    this.bubbleItems[this.bubbleItems.length - 1].loadComplete = true;
                    this.bubbleItems[this.bubbleItems.length - 1].thinkingStatus = 'end';
                }
                this.senderLoading = false;
            }
        },

        // 获取文件解析状态（带重试机制）
        async getParsingStatusWithRetry(fileId, maxRetries = 3) {
            let lastError;
            for (let attempt = 1; attempt <= maxRetries; attempt++) {
                try {
                    let response = await this.getParsingStatus(fileId);
                    // 解析响应字符串（如果返回的是字符串）
                    if (typeof response === 'string') {
                        response = this.parseResponseString(response);
                    }
                    return response;
                } catch (error) {
                    lastError = error;
                    // 最后一次尝试失败时抛出错误
                    if (attempt === maxRetries) {
                        throw error;
                    }
                    // 重试前等待一段时间
                    await new Promise(resolve => setTimeout(resolve, 500 * attempt));
                }
            }
            throw lastError || new Error('获取文件解析状态失败');
        },

        // 解析响应字符串辅助函数
        parseResponseString(responseString) {
            try {
                return JSON.parse(responseString);
            } catch (parseError) {
                throw new Error('解析状态响应格式错误');
            }
        },

        // 读取文件内容的方法，支持多种文件格式解析
        async readFileContent(file) {
            try {
                // 验证文件
                if (!file || !file.imgFile || !(file.imgFile instanceof File)) {
                    throw new Error('无效的文件对象');
                }

                // 文件大小限制检查 (100MB)
                const MAX_FILE_SIZE = 100 * 1024 * 1024;
                if (file.imgFile.size > MAX_FILE_SIZE) {
                    throw new Error(`文件大小超过限制 (最大${MAX_FILE_SIZE / (1024 * 1024)}MB)`);
                }

                // 第一步：调用addFileRequest方法上传文件到阿里云百炼
                let uploadResponse = null;
                const res = await this.addFileRequest([file.imgFile]);

                // 处理不同的响应格式
                if (Array.isArray(res) && res.length > 0) {
                    uploadResponse = res[0];
                } else if (res) {
                    uploadResponse = res;
                }

                if (!uploadResponse) {
                    throw new Error('文件上传响应为空');
                }

                // 解析响应字符串（如果返回的是字符串）
                if (typeof uploadResponse === 'string') {
                    try {
                        uploadResponse = JSON.parse(uploadResponse);
                        // this.debug('成功解析响应字符串:', uploadResponse);
                    } catch (parseError) {
                        // this.error('解析上传响应字符串失败:', parseError);
                        const error = new Error('解析上传响应失败');
                        error.type = 'parse_error';
                        throw error;
                    }
                }

                // 从响应中提取fileId（支持多种响应格式）
                let fileId;
                // 检查多种可能的fileId位置
                const fileIdLocations = [
                    { path: 'Body.Data.FileId', getter: () => uploadResponse.Body?.Data?.FileId },
                    { path: 'fileId', getter: () => uploadResponse.fileId },
                    { path: 'data.file_ids[0]', getter: () => uploadResponse.data?.file_ids?.[0] },
                    { path: 'file_ids[0]', getter: () => uploadResponse.file_ids?.[0] },
                    { path: 'id', getter: () => uploadResponse.id },
                ];

                for (const { path, getter } of fileIdLocations) {
                    try {
                        const id = getter();
                        if (id) {
                            fileId = id;
                            // this.debug(`成功从${path}提取fileId:`, fileId);
                            break;
                        }
                    } catch (e) {
                        // this.debug(`从${path}提取fileId失败，继续尝试其他位置`);
                        // 忽略单个提取方法的错误
                    }
                }

                if (!fileId) {
                    // this.error('无法从响应中提取fileId:', uploadResponse);
                    const error = new Error('文件上传失败，未返回有效的fileId');
                    error.type = 'file_error';
                    throw error;
                }

                // 第二步：调用getParsingStatus方法检查文件解析状态（使用优化的重试策略）
                let parsingStatus = null;
                const MAX_RETRIES = 50; // 增加最大重试次数
                const BASE_DELAY = 1000; // 基础延迟时间
                const MAX_DELAY = 5000; // 最大延迟时间
                const RETRY_BACKOFF = 1.2; // 退避系数

                let currentDelay = BASE_DELAY;
                let parsingComplete = false;

                // 抽取状态提取逻辑为单独函数
                const extractStatusFromResponse = response => {
                    const statusLocations = [
                        { path: 'Body.Data.Status', getter: () => response.Body?.Data?.Status },
                        { path: 'data.file_status', getter: () => response.data?.file_status },
                        { path: 'Status', getter: () => response.Status },
                        { path: 'status', getter: () => response.status },
                        { path: 'data.status', getter: () => response.data?.status },
                    ];

                    for (const { getter } of statusLocations) {
                        try {
                            const status = getter();
                            if (status) {
                                return status;
                            }
                        } catch (e) {
                            // 忽略单个提取方法的错误
                        }
                    }
                    return null;
                };

                // 定义状态检查辅助函数
                const checkStatus = status => {
                    const successStatuses = ['PARSE_SUCCESS', 'SUCCESS', 'FILE_IS_READY', 'READY'];
                    const failedStatuses = ['PARSE_FAILED', 'FAILED', 'ERROR', 'PARSE_ERROR'];

                    if (status && successStatuses.includes(status)) {
                        return { complete: true, success: true };
                    }
                    if (status && failedStatuses.includes(status)) {
                        const error = new Error(`文件解析失败: ${status}`);
                        error.type = 'file_error';
                        error.parsingStatus = status;
                        return { complete: true, success: false, error };
                    }
                    return { complete: false };
                };

                // 主重试循环
                for (let retryCount = 1; retryCount <= MAX_RETRIES; retryCount++) {
                    try {
                        // 获取解析状态（带重试）
                        const statusResponse = await this.getParsingStatusWithRetry(fileId, 3);

                        // 提取解析状态
                        parsingStatus = extractStatusFromResponse(statusResponse);

                        // 检查状态
                        const statusCheck = checkStatus(parsingStatus);

                        if (statusCheck.complete) {
                            if (statusCheck.success) {
                                parsingComplete = true;
                                break;
                            } else {
                                throw statusCheck.error;
                            }
                        }

                        // 使用指数退避策略等待
                        await this.delay(currentDelay);
                        // 增加延迟但不超过最大值
                        currentDelay = Math.min(currentDelay * RETRY_BACKOFF, MAX_DELAY);
                    } catch (statusError) {
                        // 只有明确的失败状态才抛出异常，其他错误继续重试
                        if (statusError.message && statusError.message.includes('文件解析失败:')) {
                            throw statusError;
                        }

                        // 状态查询失败，仍然继续尝试
                        await this.delay(currentDelay);
                        currentDelay = Math.min(currentDelay * RETRY_BACKOFF, MAX_DELAY);
                    }
                }

                // 如果超过最大重试次数，抛出超时错误
                if (!parsingComplete) {
                    const error = new Error(`文件解析超时，请稍后重试 (已尝试${MAX_RETRIES}次)`);
                    error.type = 'timeout';
                    error.maxRetries = MAX_RETRIES;
                    throw error;
                }

                // 返回包含详细信息的结果对象
                return {
                    fileId,
                    fileName: file.name,
                    originalFileName: file.imgFile.name,
                    fileSize: file.imgFile.size,
                    fileType: file.imgFile.type,
                    parsingStatus,
                };
            } catch (error) {
                // 增强错误对象，保留原始错误信息
                if (!error.type) {
                    error.type = 'file_error';
                }
                // 添加文件信息到错误对象
                error.fileInfo = {
                    name: file.name,
                    size: file.imgFile?.size,
                    type: file.imgFile?.type,
                };

                // 包装错误信息，提供更详细的上下文
                const wrappedError = new Error(`文件处理失败: ${error.message || '未知错误'}`);
                wrappedError.originalError = error;
                wrappedError.type = error.type;
                wrappedError.fileInfo = error.fileInfo;
                throw wrappedError;
            }
        },

        // 调用 阿里云百炼
        async callDeepseekAPI(question, sessionFileIds, onChunk) {
            const startTime = Date.now();
            this.abortController = new AbortController();
            try {
                const response = await this.makeApiRequest(question, sessionFileIds);
                if (!response.ok) {
                    throw new Error(`API 请求失败: ${response.status}`);
                }

                if (!response.body) {
                    throw new Error('响应体为空，无法读取流数据。');
                }
                await this.processResponseStream(response, onChunk);
            } catch (error) {
                this.handleApiError(error);
            }
        },

        // 提取 API 请求逻辑
        async makeApiRequest(question, sessionFileIds = []) {
            const token = window.sessionStorage.getItem('token');
            // 构建请求体
            const requestBody = {
                input: {
                    prompt: question, // 使用传入的question参数（包含图片描述）
                    stream: true,
                    incremental_output: true,
                },
                parameters: {
                    has_thoughts: true,
                    incremental_output: true,
                    rag_options: {
                        session_file_ids: sessionFileIds, // 使用传入的sessionFileIds参数
                    },
                },
                debug: {},
            };
            // 如果存在sessionId，添加到请求体中以关联上下文
            if (this.sessionId) {
                requestBody.input.session_id = this.sessionId;
            }
            const apiUrl = `/ai-api/dashscope/completion/${this.uniqueCode}`;

            try {
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'text/event-stream;charset=UTF-8',
                        Authorization: token,
                        Accept: 'text/event-stream',
                    },
                    body: JSON.stringify(requestBody),
                    signal: this.abortController.signal,
                });
                return response;
            } catch (error) {
                throw error;
            }
        },

        // 提取响应流处理逻辑
        async processResponseStream(response, onChunk) {
            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            try {
                // 主循环：持续读取数据直到流结束
                let continueReading = true;
                while (continueReading) {
                    // 读取数据块
                    const readResult = await reader.read();

                    // 检查是否暂停
                    if (this.isPaused) {
                        // 保存状态并等待恢复
                        this.pausedReader = reader;
                        this.pausedResponse = response;
                        this.pausedBuffer = buffer;

                        // 等待恢复
                        await this.waitForResume();

                        // 如果仍然暂停（可能是超时），停止处理
                        if (this.isPaused) {
                            return;
                        }

                        // 恢复后继续处理
                        continue;
                    }

                    // 检查流是否结束
                    if (readResult.done) {
                        continueReading = false;
                        continue;
                    }

                    // 处理接收到的数据
                    buffer += decoder.decode(readResult.value);
                    const lines = buffer.split('\n');
                    buffer = lines.pop() || '';

                    // 处理每行数据
                    const shouldStop = await this.processStreamLines(lines, onChunk);
                    if (shouldStop) {
                        continueReading = false; // 如果处理出错或遇到结束标记，停止处理
                        continue;
                    }
                }

                // 处理剩余缓冲区数据
                if (buffer.trim()) {
                    this.handleRemainingBuffer(buffer, onChunk);
                }
            } catch (error) {
                // 确保reader被释放
                try {
                    await reader.cancel();
                } catch (cancelError) {
                    // 忽略取消错误
                }
            } finally {
                // 确保reader被释放
                try {
                    if (reader) {
                        await reader.cancel();
                    }
                } catch (cancelError) {
                    // 忽略取消错误
                }
            }
        },

        // 处理暂停逻辑
        async handlePause(reader, response, buffer) {
            // 保存当前状态
            this.pausedReader = reader;
            this.pausedResponse = response;
            this.pausedBuffer = buffer;

            // 等待恢复
            await this.waitForResume();

            // 如果仍然暂停（可能是超时），返回false表示无法恢复
            return !this.isPaused;
        },

        // 处理流中的多行数据
        async processStreamLines(lines, onChunk) {
            for (const line of lines) {
                // 跳过非数据行
                if (!line.startsWith('data:')) {
                    continue;
                }
                // 提取和修复数据
                const data = line.slice(5);
                const fixedData = data.replace(/\\\\"/g, '\\"').replace(/\\\\/g, '\\');
                // 检查是否结束标记
                if (fixedData === '[DONE]') {
                    return true; // 表示应该停止处理
                }
                // 处理数据块，如果失败则停止
                if (!await this.processChunk(fixedData, onChunk)) {
                    return true;
                }
            }
            return false; // 继续处理
        },

        // 处理剩余缓冲区数据
        handleRemainingBuffer(buffer, onChunk) {
            if (buffer.trim() && buffer.trim() !== '[DONE]') {
                this.processRemainingBuffer(buffer, onChunk);
            }
        },

        // 继续处理响应流
        async continueResponseStream(response, reader, buffer, onChunk) {
            const decoder = new TextDecoder();
            try {
                // 检查暂停状态
                if (this.isPaused) {
                    this.savePauseState(reader, response, buffer);
                    return; // 再次暂停，退出处理
                }
                // 读取数据
                const readResult = await reader.read();
                if (readResult.done) {
                    return; // 流结束
                }
                // 处理数据
                buffer += decoder.decode(readResult.value);
                const lines = buffer.split('\n');
                buffer = lines.pop() || '';
                // 使用已有的processStreamLines函数处理行数据
                const shouldStop = await this.processStreamLines(lines, onChunk);
                if (shouldStop) {
                    return; // 停止处理
                }

                // 处理剩余缓冲区
                this.handleRemainingBuffer(buffer, onChunk);
            } finally {
                // 无论成功失败都清理暂停状态
                this.cleanupPauseState();
            }
        },

        // 保存暂停状态
        savePauseState(reader, response, buffer) {
            this.pausedReader = reader;
            this.pausedResponse = response;
            this.pausedBuffer = buffer;
        },

        // 清理暂停状态
        cleanupPauseState() {
            this.pausedReader = null;
            this.pausedResponse = null;
            this.pausedBuffer = '';
        },

        // 通用延迟函数，避免在循环中重复创建匿名函数
        delay(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },

        // 提取数据块解析逻辑
        async processChunk(data, onChunk) {
            try {
                const parsed = JSON.parse(data);
                const content = this.extractContentFromResponse(parsed);
                if (content) {
                    onChunk(content);
                }
            } catch (e) {
                this.handleErrorState();
                return false; // 停止读取
            }
            return true; // 继续读取
        },

        // 处理缓冲区中剩余的数据
        processRemainingBuffer(buffer, onChunk) {
            try {
                const fixedBuffer = buffer.replace(/\\\\"/g, '\\"').replace(/\\\\/g, '\\');
                const parsed = JSON.parse(fixedBuffer);
                const content = this.extractContentFromResponse(parsed);
                if (content) {
                    onChunk(content);
                }
            } catch (e) {
                onChunk(buffer); // 如果不是 JSON，当作纯文本处理
                this.handleErrorState();
            }
        },

        // 提取错误处理逻辑
        // 错误代码映射表
        errorCodeMap() {
            return {
                NETWORK_ERROR: '网络连接失败，请检查您的网络设置',
                TIMEOUT_ERROR: '请求超时，请稍后重试',
                AUTH_ERROR: '认证失败，请重新登录',
                RATE_LIMIT_ERROR: '请求过于频繁，请稍后再试',
                SERVER_ERROR: '服务器繁忙，请稍后再试',
                UNKNOWN_ERROR: '很抱歉，请求过程中遇到了问题',
                FILE_ERROR: '文件处理失败，请检查文件格式和大小',
                PARSE_ERROR: '解析响应失败',
                CONTEXT_LIMIT_ERROR: '上下文过长，请简化您的问题或开始新对话',
            };
        },

        // 处理API错误
        handleApiError(error) {
            // 如果是用户主动取消的请求，不显示错误提示
            if (error instanceof Error && error.name === 'AbortError') {
                // 设置取消状态而不是错误状态
                const currentAIReply = this.bubbleItems.find(item => item.role === 'ai' && !item.loadComplete);
                if (currentAIReply) {
                    currentAIReply.thinkingStatus = 'cancelled';
                    currentAIReply.text = '请求已取消';
                    currentAIReply.loadComplete = true;
                }
                return; // 不抛出错误，避免后续处理
            }
            // 记录详细的错误信息
            const errorDetails = {
                name: error.name,
                message: error.message,
                status: error.status || error.response?.status,
                stack: process.env.NODE_ENV === 'development' ? error.stack : null,
            };
            // 分析错误类型，获取用户友好的错误消息
            const errorMessage = this.getFriendlyErrorMessage(error);
            // 设置错误状态和消息
            this.handleErrorState(errorMessage, error);
            // 抛出增强的错误对象，包含用户友好的消息
            const enhancedError = new Error(errorMessage);
            enhancedError.originalError = error;
            enhancedError.isHandled = true;
            throw enhancedError;
        },

        // 获取用户友好的错误消息
        getFriendlyErrorMessage(error) {
            if (!error) {return this.errorCodeMap().UNKNOWN_ERROR;}
            // 处理特定错误类型
            if (error.type === 'file_error' || error.message?.includes('file')) {
                return this.errorCodeMap().FILE_ERROR;
            }
            if (error.type === 'parse_error' || error.name === 'SyntaxError') {
                return this.errorCodeMap().PARSE_ERROR;
            }
            if (error.message?.includes('context') || error.message?.includes('长度限制')) {
                return this.errorCodeMap().CONTEXT_LIMIT_ERROR;
            }
            // 处理网络错误
            if (!navigator.onLine || error.message?.includes('Network')) {
                return this.errorCodeMap().NETWORK_ERROR;
            }
            // 处理超时错误
            if (error.name === 'TimeoutError' ||
                error.message?.includes('timeout') ||
                error.message?.includes('超时')) {
                return this.errorCodeMap().TIMEOUT_ERROR;
            }
            // 处理HTTP状态码
            if (error.status) {
                if (error.status === 401 || error.status === 403) {
                    return this.errorCodeMap().AUTH_ERROR;
                } if (error.status === 429) {
                    return this.errorCodeMap().RATE_LIMIT_ERROR;
                } if (error.status >= 500) {
                    return this.errorCodeMap().SERVER_ERROR;
                }
            }
            // 处理响应对象中的错误
            if (error.response) {
                if (error.response.status === 401 || error.response.status === 403) {
                    return this.errorCodeMap().AUTH_ERROR;
                } if (error.response.status === 429) {
                    return this.errorCodeMap().RATE_LIMIT_ERROR;
                } if (error.response.status >= 500) {
                    return this.errorCodeMap().SERVER_ERROR;
                } if (error.response.data && error.response.data.message) {
                    return error.response.data.message;
                }
            }
            // 返回错误消息或默认消息
            const result = error.message || this.errorCodeMap().UNKNOWN_ERROR;
            return result;
        },

        // 设置错误状态和用户友好的错误消息
        handleErrorState(errorMessage, originalError) {
            const currentAIReply = this.bubbleItems.find(item => item.role === 'ai' && !item.loadComplete);
            if (currentAIReply) {
                currentAIReply.thinkingStatus = 'error';
                currentAIReply.text = errorMessage;
                currentAIReply.loadComplete = true;
                currentAIReply.errorType = this.getErrorType(originalError);
                currentAIReply.timestamp = new Date().toISOString();
                // 添加错误详情
                if (originalError) {
                    currentAIReply.errorDetails = {
                        message: originalError.message,
                        name: originalError.name,
                        status: originalError.status || originalError.response?.status,
                        code: originalError.code,
                        timestamp: new Date().toISOString(),
                    };
                    // 在开发环境下添加堆栈信息
                    if (process.env.NODE_ENV === 'development') {
                        currentAIReply.errorDetails.stack = originalError.stack;
                    }
                }
                // 添加重试信息 - 对于网络错误和超时错误可以重试
                if (this.canRetry(originalError)) {
                    currentAIReply.canRetry = true;
                }
            }
            // 重置加载状态
            this.senderLoading = false;
            this.thinkingStatus = null;
            // 触发全局错误事件，便于其他组件处理
            this.$emit('ai-error', {
                message: errorMessage,
                originalError,
                timestamp: new Date(),
                errorType: this.getErrorType(originalError),
                canRetry: this.canRetry(originalError),
            });
        },

        // 判断错误类型
        getErrorType(error) {
            if (!error) {return 'unknown';}
            if (error.name === 'AbortError') {return 'abort';}
            if (error.name === 'TimeoutError' || error.message?.includes('timeout')) {return 'timeout';}
            if (!navigator.onLine || error.message?.includes('Network')) {return 'network';}
            if (error.status === 401 || error.status === 403 || error.response?.status === 401 || error.response?.status === 403) {return 'auth';}
            if (error.status === 429 || error.response?.status === 429) {return 'rate_limit';}
            if (error.status >= 500 || error.response?.status >= 500) {return 'server';}
            if (error.type === 'file_error' || error.message?.includes('file')) {return 'file';}
            if (error.type === 'parse_error' || error.name === 'SyntaxError') { return 'parse'; }

            return 'unknown';
        },

        // 判断是否可以重试
        canRetry(error) {
            const errorType = this.getErrorType(error);
            // 网络错误、超时错误和服务器错误可以重试
            return ['network', 'timeout', 'server'].includes(errorType);
        },
        // 提取响应内容的辅助函数
        extractContentFromResponse(parsed) {
            // 获取当前 AI 回复对象
            const currentAIReply = this.bubbleItems.find(item => item.role === 'ai' && !item.loadComplete);
            if (!currentAIReply) { return ''; }
            // 更新状态为 thinking
            if (currentAIReply.thinkingStatus !== 'thinking') {
                currentAIReply.thinkingStatus = 'thinking';
            }

            // 提取并保存session_id，用于关联上下文
            if (parsed.session_id || parsed.output?.session_id) {
                this.sessionId = parsed.session_id || parsed.output.session_id;
            }

            // 提取思考过程并逐步更新到 Thinking 组件
            if (parsed.output?.thoughts) {
                const thoughts = parsed.output.thoughts;
                // 获取最新的思考步骤
                const latestThought = thoughts[thoughts.length - 1];
                const thoughtText = latestThought?.thought || latestThought?.response || '';
                if (thoughtText) {
                    // 将新思考步骤追加到现有内容中（使用空格分隔）
                    currentAIReply.thinkingSteps = `${currentAIReply.thinkingSteps || ''}${currentAIReply.thinkingSteps ? ' ' : ''}${thoughtText}`;
                }
            }
            // 返回主要文本内容
            return parsed.choices?.[0]?.delta?.content || parsed.output?.choices?.[0]?.message?.content || parsed.output?.text || parsed.result || parsed.content || '';
        },

        // 取消发送
        cancelSend() {
            if (this.abortController) {
                this.abortController.abort();
                this.abortController = null;
            }
            if (this.bubbleItems.length > 0) {
                this.bubbleItems[this.bubbleItems.length - 1].loading = false;
            }
            this.$nextTick(() => {
                this.clearSend();
            });
        },

        // 清空输入
        clearSend() {
            this.senderValue = '';
            this.files = [];
        },

        // 复制文本
        copyText(text) {
            if (!text) { return; }
            navigator.clipboard
                .writeText(text)
                .then(() => {
                    Message({ showClose: true, message: '文本已复制到剪贴板', type: 'success' });
                })
                .catch(err => {
                    Message({ showClose: true, message: `复制文本失败: ${err}`, type: 'error' });
                });
        },

        // 刷新文本
        refreshText(text) {
            if (!text) { return; }
            const lastUserIndex = this.bubbleItems.length - 1 - this.bubbleItems.slice().reverse().findIndex(item => item.role === 'user');
            if (lastUserIndex >= this.bubbleItems.length) { return; } // 表示未找到
            // 获取用户消息内容
            const userMessage = this.bubbleItems[lastUserIndex];
            if (!userMessage) { return; }
            // 删除该用户消息之后的所有消息（包括AI回复）
            this.bubbleItems.splice(lastUserIndex + 1);
            // 重新发送消息
            this.senderValue = userMessage.text;
            if (userMessage.files && userMessage.files.length > 0) {
                this.files = userMessage.files;
            }
            this.handleSend();
        },

        // 加载语音按钮
        loadVoiceButton(item) {
            let buttonIcon;
            if (item.voiceStatus === 'playing') {
                buttonIcon = '\ue76f'; // 播放中，显示暂停图标
            } else if (item.voiceStatus === 'paused') {
                buttonIcon = '\ue8bc'; // 暂停中，显示播放图标
            } else {
                buttonIcon = '\ue7ae'; // 未播放，显示播放图标
            }
            return buttonIcon;
        },

        // 语音播报
        voiceAnnouncements(text, item) {
            // 如果点击的是当前正在播报的项
            if (this.currentVoiceItem === item.key) {
                // 如果当前正在播放，则暂停
                if (item.voiceStatus === 'playing') {
                    window.speechSynthesis.pause();
                    item.voiceStatus = 'paused';
                    return;
                }
                if (item.voiceStatus === 'paused') {// 如果当前暂停，则继续播放
                    window.speechSynthesis.resume();
                    item.voiceStatus = 'playing';
                    return;
                }
            }
            // 如果有其他项正在播报，先停止它
            if (this.currentUtterance) {
                window.speechSynthesis.cancel();
                if (this.currentVoiceItem) {
                    const prevItem = this.bubbleItems.find(i => i.key === this.currentVoiceItem);
                    if (prevItem) {
                        prevItem.voiceStatus = 'stopped';
                    }
                }
            }
            // 清洗文本：移除 Markdown 格式符号
            const cleanText = text
                .replace(/[#*`~\-_]/g, '') // 移除常见 Markdown 符号
                .replace(/\[.*?\]\(.*?\)/g, '') // 移除 Markdown 链接
                .replace(/!\[.*?\]\(.*?\)/g, '') // 移除 Markdown 图片
                .replace(/\*\*(.*?)\*\*/g, '$1') // 替换 **粗体** 为普通文本
                .replace(/\*(.*?)\*/g, '$1') // 替换 *斜体* 为普通文本
                .replace(/```.*?```/g, '') // 移除代码块
                .replace(/`([^`]+)`/g, '$1') // 替换单行代码为普通文本
                .trim();
            const utterance = new SpeechSynthesisUtterance(cleanText);
            utterance.lang = 'zh-CN';
            utterance.rate = 1.5;
            this.currentUtterance = utterance;
            this.currentVoiceItem = item.key;
            utterance.onstart = () => {
                item.voiceStatus = 'playing';
            };
            utterance.onend = () => {
                item.voiceStatus = 'stopped';
                this.currentUtterance = null;
                this.currentVoiceItem = null;
            };
            utterance.onerror = () => {
                item.voiceStatus = 'stopped';
                this.currentUtterance = null;
                this.currentVoiceItem = null;
            };
            speechSynthesis.speak(utterance);
        },

        // 停止语音播报
        stopVoiceAnnouncements() {
            if (this.currentUtterance) {
                window.speechSynthesis.cancel();
                this.currentUtterance = null;
            }
        },

        // 加载文件
        async loadFiles(fileList) {
            this.files.forEach(existingFile => {
                if (existingFile.imgUrl) {
                    URL.revokeObjectURL(existingFile.imgUrl);
                }
            });

            // 立即将文件添加到files数组，并为每个文件标记状态
            fileList.forEach(file => {
                const tempFile = { ...file };

                // 处理图片文件 - 立即显示
                if (file.imgFile instanceof File) {
                    // 检查是否为图片文件
                    // if (file.imgFile.type.startsWith('image/')) {
                    //     // 创建图片预览URL
                    //     const imgUrl = URL.createObjectURL(file.imgFile);
                    //     tempFile.imgUrl = imgUrl;
                    //     tempFile.parsing = false; // 图片不需要解析
                    //     tempFile.parsed = true;
                    //     // 为图片文件立即异步获取fileId，避免在发送时重复解析
                    //     this.getImageFileId(tempFile);
                    // } else {
                        // 非图片文件 - 标记为解析中状态
                    tempFile.parsing = true;
                    tempFile.parsed = false;
                    tempFile.parseError = false;
                    // }
                }

                // 立即添加到显示列表
                this.files.push(tempFile);
                this.hideAttachments = false;
                // 对于非图片文件，异步处理解析
                // if (file.imgFile instanceof File && !file.imgFile.type.startsWith('image/')) {
                this.processNonImageFile(tempFile);
                // }
            });

            this.senderValue = '';
            if (this.$refs.senderRef) {
                this.$refs.senderRef.openHeader();
            }
        },

        // 为图片文件异步获取fileId
        async getImageFileId(tempFile) {
            try {
                const content = await this.readFileContent(tempFile);
                const fileIndex = this.files.findIndex(f => f === tempFile);
                if (fileIndex !== -1) {
                    this.files[fileIndex].fileId = content.fileId; // 保存fileId
                }
            } catch (error) {
                // 处理错误，但不影响图片显示
                console.error('获取图片fileId失败:', error);
            }
        },

        // 异步处理非图片文件的解析
        async processNonImageFile(tempFile) {
            try {
                // 读取文件内容（上传和等待解析）
                const content = await this.readFileContent(tempFile);

                // 查找文件并更新状态
                const fileIndex = this.files.findIndex(f => f === tempFile);
                if (fileIndex !== -1) {
                    // 更新文件状态为已解析，并保存fileId
                    this.files[fileIndex].content = content;
                    this.files[fileIndex].fileId = content.fileId; // 保存fileId，避免重复解析
                    this.files[fileIndex].parsing = false;
                    this.files[fileIndex].parsed = true;
                }
            } catch (error) {
                // 查找文件并更新为解析失败状态
                const fileIndex = this.files.findIndex(f => f === tempFile);
                if (fileIndex !== -1) {
                    this.files[fileIndex].parsing = false;
                    this.files[fileIndex].parsed = false;
                    this.files[fileIndex].parseError = true;
                    this.files[fileIndex].errorMessage = error.message || '文件解析失败';
                }
                this.handleFileError(error);
            }
        },

        // 删除文件
        deleteFileCard(_item, index) {
            // 获取要删除的文件
            const fileToDelete = this.files[index];
            // 释放URL对象
            if (fileToDelete && fileToDelete.imgUrl) {
                URL.revokeObjectURL(fileToDelete.imgUrl);
            }

            // 检查并从数组中移除对应的fileId
            if (fileToDelete && fileToDelete.fileId && this.lastUploadedFileId.includes(fileToDelete.fileId)) {
                const index = this.lastUploadedFileId.indexOf(fileToDelete.fileId);
                if (index > -1) {
                    this.lastUploadedFileId.splice(index, 1);
                }
            }

            // 删除文件
            this.files.splice(index, 1);
            if (this.files.length === 0 && this.$refs.senderRef) {
                this.$refs.senderRef.closeHeader();
            }
        },

        // 获取用户llmapps
        getuserllmapps() {
            return this.$axios.$get('/ai-api/llmapp/getuserllmapps');
        },

        // 暂停/继续生成
        togglePause() {
            if (this.isPaused) {
                this.resumeGeneration();
            } else {
                this.pauseGeneration();
            }
        },

        // 暂停生成
        pauseGeneration() {
            this.isPaused = true;
            Message({ showClose: true, message: '已暂停生成', type: 'info' });
        },

        // 继续生成
        async resumeGeneration() {
            this.isPaused = false;
            Message({ showClose: true, message: '继续生成中...', type: 'info' });
            // 不需要手动调用continueResponseStream，因为processResponseStream中的waitForResume()会检测到isPaused=false并继续执行
            // 清理暂停状态变量，让流处理逻辑自然恢复
            this.pausedReader = null;
            this.pausedResponse = null;
            this.pausedBuffer = '';
        },

        // 等待暂停状态解除
        waitForResume() {
            // 使用更高间隔减少CPU占用，同时添加最大等待时间
            const MAX_WAIT_TIME = 30000; // 30秒最大等待
            const CHECK_INTERVAL = 300; // 300ms检查一次
            return new Promise(resolve => {
                const startTime = Date.now();
                const checkResume = () => {
                    // 检查是否已解除暂停
                    if (!this.isPaused) {
                        resolve();
                        return;
                    }
                    // 检查是否超过最大等待时间
                    if (Date.now() - startTime > MAX_WAIT_TIME) {
                        resolve(); // 超时后也继续执行
                        return;
                    }
                    // 继续等待
                    setTimeout(checkResume, CHECK_INTERVAL);
                };
                checkResume();
            });
        },

        // 切换语音识别
        toggleSpeechRecognition() {
            if (this.isRecording) {
                this.stopSpeechRecognition();
            } else {
                this.startSpeechRecognition();
            }
        },

        // 切换助手面板显示状态
        toggleAssistant() {
            if (!this.hasPermission) {
                this.$message({ showClose: true, message: '当前账号暂无AI小助手权限！', type: 'warning' });
                return;
            }
            this.isExpanded = !this.isExpanded;
        },
        // 开始语音识别
        startSpeechRecognition() {
            // 检查浏览器是否支持语音识别
            if (!('webkitSpeechRecognition' in window) && !('SpeechRecognition' in window)) {
                Message({ showClose: true, message: '您的浏览器不支持语音识别功能', type: 'warning' });
                return;
            }
            // 创建语音识别实例
            const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
            this.recognition = new SpeechRecognition();
            // 配置语音识别
            this.recognition.continuous = false;
            this.recognition.interimResults = true;
            this.recognition.lang = 'zh-CN';
            // 语音识别开始事件
            this.recognition.onstart = () => {
                this.isRecording = true;
                Message({ showClose: true, message: '语音识别已开始，请说话...', type: 'info' });
            };
            // 语音识别结果事件
            this.recognition.onresult = event => {
                let finalTranscript = '';
                let interimTranscript = '';

                for (let i = event.resultIndex; i < event.results.length; i++) {
                    const transcript = event.results[i][0].transcript;
                    if (event.results[i].isFinal) {
                        finalTranscript += transcript;
                    } else {
                        interimTranscript += transcript;
                    }
                }
                // 更新输入框内容
                if (finalTranscript) {
                    this.senderValue = finalTranscript;
                } else if (interimTranscript) {
                    this.senderValue = interimTranscript;
                }
            };
            // 语音识别结束事件
            this.recognition.onend = () => {
                this.isRecording = false;
                Message({ showClose: true, message: '语音识别已结束', type: 'info' });
            };
            // 语音识别错误事件
            this.recognition.onerror = event => {
                this.isRecording = false;
                let errorMessage = '语音识别出错';
                switch (event.error) {
                    case 'not-allowed':
                        errorMessage = '请允许浏览器使用麦克风权限';
                        break;
                    case 'audio-capture':
                        errorMessage = '无法访问麦克风';
                        break;
                    case 'network':
                        errorMessage = '网络连接错误';
                        break;
                    case 'no-speech':
                        errorMessage = '未检测到语音输入';
                        break;
                }
                Message({ showClose: true, message: errorMessage, type: 'error' });
            };
            // 开始语音识别
            try {
                this.recognition.start();
            } catch (error) {
                Message({ showClose: true, message: '启动语音识别失败', type: 'error' });
            }
        },

        // 停止语音识别
        stopSpeechRecognition() {
            if (this.recognition) {
                // 移除事件监听器
                this.recognition.onstart = null;
                this.recognition.onresult = null;
                this.recognition.onend = null;
                this.recognition.onerror = null;
                this.recognition.stop();
                this.recognition = null;
                this.isRecording = false;
            }
        },

        // 清空所有状态
        clearAll() {
            // 停止语音识别
            if (this.isRecording) {
                this.stopSpeechRecognition();
            }
            // 停止语音播报
            this.stopVoiceAnnouncements();
            // 取消正在进行的请求
            if (this.abortController) {
                this.abortController.abort();
                this.abortController = null;
            }
            // 重置暂停状态
            this.isPaused = false;
            this.pausedReader = null;
            this.pausedResponse = null;
            this.pausedBuffer = '';
            // 清空输入框和文件
            this.senderValue = '';
            this.sessionId = '';
            this.files = [];
            this.lastUploadedFileId = [];
            // 关闭文件上传面板
            if (this.$refs.senderRef) {
                this.$refs.senderRef.closeHeader();
            }
            // 如果正在生成中，停止生成状态
            if (this.senderLoading) {
                this.senderLoading = false;
                Message({ showClose: true, message: '已停止生成并清空所有内容', type: 'info' });
            } else {
                Message({ showClose: true, message: '已清空输入和文件', type: 'info' });
            }
            // 重置语音识别状态
            this.isRecording = false;
            if (this.recognition) {
                this.recognition = null;
            }
        },
        loadIconClass(name) {
            let fileIcon = '';
            const suffix = name.split('.')[1];
            if (suffix.includes('txt')) {
                fileIcon = 'ai-txt1';
            } else if (suffix.includes('doc')) {
                fileIcon = 'ai-doc';
            } else if (suffix.includes('ex')) {
                fileIcon = 'ai-excel1';
            } else if (suffix.includes('xls')) {
                fileIcon = 'ai-xls';
            } else if (suffix.includes('pdf')) {
                fileIcon = 'ai-pdf1';
            } else if (suffix.includes('ppt')) {
                fileIcon = 'ai-PPT';
            } else if (['png', '', 'jpg', 'jpeg', 'gif', 'bmp', 'svg', 'webp', 'tif', 'tiff', 'psd', 'ai', 'eps', 'ico', 'svgz'].includes(suffix)) {
                fileIcon = 'ai-tupian';
            } else {
                fileIcon = 'ai-qitawenjiangeshi';
            }
            return fileIcon;
        },
        // 添加文件上传请求
        async addFileRequest(files) {
            try {
                // 参数验证
                if (!Array.isArray(files) || files.length === 0) {
                    throw new Error('文件数组为空或无效');
                }
                // 创建 FormData 对象
                const formData = new FormData()
                // 添加文件
                files.forEach(file => {
                    formData.append('files', file)
                })
                // 添加其他参数
                const workspaceId = this.userWorkSpaces[0]?.workspace_id;
                formData.append('WorkspaceId', workspaceId);
                formData.append('CategoryId', 'default')
                formData.append('Parser', 'DASHSCOPE_DOCMIND')
                formData.append('CategoryType', 'SESSION_FILE')
                formData.append('UseInternalEndpoint', 'false')
                formData.append('Tags', '')
                // 上传文件
                const response = await this.$axios.$post('/ai-api/applicationdata/importfile', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    timeout: 300000, // 设置5分钟超时
                    onUploadProgress: progressEvent => {
                        // 更新上传进度
                        if (progressEvent.total) {
                            const progress = Math.round(progressEvent.loaded * 100 / progressEvent.total);
                            // 触发进度更新事件
                            this.$emit('upload-progress', {
                                progress,
                                loaded: progressEvent.loaded,
                                total: progressEvent.total,
                            });
                        }
                    },
                });
                return response;
            } catch (error) {
                // 增强错误对象
                const enhancedError = new Error(`文件上传失败: ${error.message || '未知错误'}`);
                enhancedError.type = 'file_error';
                enhancedError.originalError = error;
                enhancedError.fileCount = files.length;

                // 添加具体的错误类型
                if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
                    enhancedError.type = 'timeout';
                    enhancedError.message = '文件上传超时，请检查网络连接或文件大小';
                } else if (error.response?.status === 413) {
                    enhancedError.type = 'file_error';
                    enhancedError.message = '文件过大，请上传更小的文件';
                } else if (error.response?.status === 400) {
                    enhancedError.type = 'validation_error';
                    enhancedError.message = '文件格式不支持或验证失败';
                }

                throw enhancedError;
            }
        },
        async getuserworkspaces() {
            try {
                return await this.$axios.$get('/ai-api/llmapp/getuserworkspaces')
            } catch (error) {
                console.error('获取用户工作区失败:', error);
                return [];
            }
        },
        async getParsingStatus(fileId) {
            try {
                // 验证参数
                if (!fileId || typeof fileId !== 'string') {
                    throw new Error('无效的fileId参数');
                }
                // 获取工作区ID并验证
                const workspaceId = this.userWorkSpaces && this.userWorkSpaces.length > 0 ? this.userWorkSpaces[0].workspace_id : null;
                // 发送请求（添加超时配置）
                const config = {
                    timeout: 15000, // 设置15秒超时
                };
                let response = await this.$axios.$post('/ai-api/applicationdata/describefile', {
                        fileId: fileId,
                        workspaceId: workspaceId,
                    },
                    config
                );

                // 解析响应字符串（如果返回的是字符串）
                if (typeof response === 'string') {
                    try {
                        response = JSON.parse(response);
                    } catch (parseError) {
                        // 创建错误对象而不是静默失败
                        throw new Error(`解析响应字符串失败: ${parseError.message}`);
                    }
                }
                // 验证响应格式
                if (!response || typeof response !== 'object') {
                    throw new Error('返回的响应不是有效的对象');
                }
                return response;
            } catch (error) {
                // 详细的错误信息处理
                let errorMessage = '获取文件解析状态失败';

                if (error.response) {
                    // 服务器返回错误状态码
                    errorMessage = `${errorMessage}: HTTP ${error.response.status} ${error.response.statusText}`;
                } else if (error.request) {
                    // 请求已发送但未收到响应
                    errorMessage = `${errorMessage}: 服务器无响应，请检查网络连接`;
                } else if (error.message) {
                    // 请求配置或其他错误
                    errorMessage = `${errorMessage}: ${error.message}`;
                }

                // 创建增强的错误对象
                const enhancedError = new Error(errorMessage);
                enhancedError.originalError = error;
                enhancedError.fileId = fileId;

                throw enhancedError;
            }
        },
        thoughtProcess(item) {
            if (item.thinkingStatus === 'end') {
                const typewriterRef = this.$refs[`ref_thoughtProcessTypewriter_${item.key}`];
                if (typewriterRef) {
                    typewriterRef.finishTyping();
                } else {
                    this.$nextTick(() => {
                        const delayedRef = this.$refs[`ref_thoughtProcessTypewriter_${item.key}`];
                        if (delayedRef) {
                            delayedRef.finishTyping();
                        }
                    });
                }
            }
        },

        getInstance(instance) {
            // 遍历所有bubble items，找到对应的item
            for (const item of this.bubbleItems) {
                const typewriterRef = this.$refs[`ref_typewriter_${item.key}`];
                if (typewriterRef) {
                    // 标记打字完成
                    item.typingComplete = true;
                    // 如果有最终结果，显示它
                    if (item.finalText) {
                        item.text = item.finalText;
                    }
                    break;
                }
            }
        },

        getAssistantInfo() {
            return this.$axios.$get('/ai-api/llmapp/getuserllmapps')
        },

        getPromptList() {
            const data = [];
            this.$axios.$get(`/ai-api/llmapp/askedgetbyuniquecode/${this.assistantInfo[0].unique_code}`).then(res => {
                res.forEach(item => {
                    data.push({
                        key: item.id,
                        label: item.asked,
                    });
                });
            });
            return data;
        },
    },
    updated() {},
    destroyed() {
        // 调用统一的资源清理方法
        this.cleanupResources();
    },
};
</script>

<style lang="stylus" scoped></style>
